import script from "./ProjectsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectsPage.vue?vue&type=style&index=0&id=2120a872&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2120a872"]])

export default __exports__